import { Component, Input, output } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { NavItem } from '@contler/models/ui';
import { Subject } from 'rxjs';

import { HotelColorDirective } from '../../directives/text-hotel-color.directive';
import { MenuItemComponent } from '../menu-item/menu-item.component';

@Component({
  selector: 'ctr-menu',
  imports: [MenuItemComponent, HotelColorDirective, MatListModule, MatIconModule],
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss'],
})
export class MenuComponent {
  @Input() navItems: NavItem[] = [];
  @Input() logo: string | null = null;
  @Input() title: string | null = null;
  @Input() subtitle?: string | null = null;
  @Input() showLogout = true;
  @Input() logoutText = '';
  logoutClick = output<void>();
  unsubscribe$: Subject<void> = new Subject<void>();
}
